<template>
  <span>
    <m-datatable :showExportBtns="false" :showSelect="false" :headers="headers" :items="items" :filters.sync="filters">
    </m-datatable>
  </span>
</template>

<script>
export default {
  props: {
    items: {},
  },
  data() {
    return {
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "نام",
          value: "first_name",
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
        },
        {
          text: "شماره تماس",
          value: "phone",
        },
        {
          text: "تاریخ ثبت نام",
          value: "created_at",
          getValue: (item) => {
            return item.created_at.split(" ")[0];
          },
        },
        {
          text: "ساعت ثبت نام",
          value: "date",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[1];
          },
        },
      ],
      filters: {
        user: null,
      },
    };
  },
};
</script>
